import React from 'react';

import { number, shape, string } from 'prop-types';

import ClassNames from 'classnames';

import BaseComponent from '../../.internal/BaseComponent';

import './TableHeader.scss';

export default class TableHeader extends BaseComponent {
  render() {
    const { rowSpan, colSpan, style, id, className, children } = this.props;

    const classNames = ClassNames(['TableHeader', className]);

    return (
      <th
        rowSpan={rowSpan}
        colSpan={colSpan}
        style={style}
        id={id}
        className={classNames}
      >
        {children}
      </th>
    );
  }
}

TableHeader.propTypes = {
  rowSpan: number,
  colSpan: number,
  style: shape({}),
  id: string,
  className: string
};

TableHeader.defaultProps = {
  rowSpan: 1,
  colSpan: 1,
  style: {},
  id: undefined,
  className: undefined
};
